import { render, staticRenderFns } from "./LittleGateHeight.vue?vue&type=template&id=fe628464&scoped=true"
import script from "./LittleGateHeight.vue?vue&type=script&lang=ts"
export * from "./LittleGateHeight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe628464",
  null
  
)

export default component.exports